//@ts-nocheck
import axios from "axios";
import Keys from "@utils/keys";
import { getEligibility } from "@config/API";

import ParametrosSolicitacaoProcedimentos from "@config/types/requests/RequisicaoSolicitacaoProcedimentos";

export * from "./biometryActions";
export const FETCH_BENEFICIARIO = "fetch_beneficiario";
export const UPDATE_BENEFICIARIO_STATE = "update_beneficiario_state";
export const RESET_BENEFICIARIO_STATE = "reset_beneficiario_state";
export const POST_ATENDIMENTO = "post_atendimento";
export const FETCH_PROCEDIMENTO = "fetch_procedimento";
export const UPDATE_PRESTADOR = "update_prestador";
export const UPDATE_PROCEDIMENTO = "update_procedimento";
export const RESET_PROCEDIMENTO = "reset_procedimento";
export const FETCH_GUIA = "fetch_guia";
export const FETCH_GUIA_CONSULTA = "fetch_guia_consulta";
export const COBRANCA = "cobranca";
export const DELETE_COBRANCA = "delete_cobranca";

const ROOT_URL = Keys.SERVICOS.API.ROOT_URL;
const BIOMETRY_CALLBACK_PARAM =
  "&url=" + Keys.BIOMETRIA.ORIGIN + "/biometria-callback";
var IdAtendimento = "";

export function getBeneficiario(params, callback, errorHandler) {
  const request = getEligibility(params)
    .then((result) => {
      if (!!result.error) throw result?.error;
      if (result.data.Elegibilidade) {
        IdAtendimento = result.data.Elegibilidade.IdAtendimento;
      }
      if (
        result.data.Biometria != null &&
        result.data.Biometria?.Utiliza &&
        result.data.Elegibilidade?.IndicadorElegibilidade === "S"
      ) {
        const {
          data: {
            Biometria: { Url },
            Elegibilidade: { NomeBeneficiario },
          },
        } = result;
        const userNameParam = "&name=" + NomeBeneficiario;
        let temp;
        temp = Url.concat(userNameParam, BIOMETRY_CALLBACK_PARAM);
        result.data.Biometria.Url = temp;
        console.log(temp);
      }
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: FETCH_BENEFICIARIO,
    payload: request,
  };
}

export function postCobranca(params, callback, errorHandler) {
  axios
    .post(`${ROOT_URL}/Cobrancas/salvar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: COBRANCA,
    payload: null,
  };
}

export function fetchGuia(params, callback, errorHandler) {
  axios(`${ROOT_URL}/Guia/exportar/${params}`, {
    method: "GET",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: FETCH_GUIA,
    payload: null,
  };
}

export function fetchGuiaConsulta(idCobranca, callback, errorHandler) {
  axios(`${ROOT_URL}/Guia/consulta/exportar/${idCobranca}`, {
    method: "GET",
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: FETCH_GUIA_CONSULTA,
    payload: null,
  };
}

export function autorizarProcedimentos(
  params: ParametrosSolicitacaoProcedimentos,
  callback,
  errorHandler
) {
  const axiosInstance = axios.create({
    timeout: 180000,
  });
  params.atendimento = IdAtendimento;
  if (params.observacao == null || params.observacao.length <= 0) {
    params.observacao = JSON.stringify({ obsGui: "AUTORIZADOR" });
  }
  const request = axiosInstance
    .post(`${ROOT_URL}/Beneficiarios/autorizar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: FETCH_PROCEDIMENTO,
    payload: request,
  };
}

export function getProfissionaisExecutantesFiltered(
  params,
  callback,
  errorHandler
) {
  axios
    .post(`${ROOT_URL}/ProfissionalExecutante/filtro/listar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function getProfissionaisExecutantes(
  idPrestador,
  callback,
  errorHandler
) {
  axios
    .get(`${ROOT_URL}/ProfissionalExecutante/listar/${idPrestador}`)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function postProfissionalExecutante(params, callback, errorHandler) {
  axios
    .post(`${ROOT_URL}/ProfissionalExecutante/salvar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: null,
  };
}

export function deleteProfissionalExecutante(params, callback, errorHandler) {
  axios
    .delete(`${ROOT_URL}/ProfissionalExecutante/excluir/${params}`)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: null,
  };
}

export function putProfissionalExecutante(params, callback, errorHandler) {
  axios
    .put(`${ROOT_URL}/ProfissionalExecutante/editar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: null,
  };
}

export function resetExameState(params) {
  return {
    type: RESET_PROCEDIMENTO,
    payload: {},
  };
}

export function updateExameState(params) {
  return {
    type: UPDATE_PROCEDIMENTO,
    payload: params,
  };
}

export function getProcedimentos(callback) {
  axios.get(`${ROOT_URL}/Procedimentos/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getProcedimentosFiltro(filtro, callback) {
  axios
    .get(`${ROOT_URL}/Procedimentos/filtrar?filtro=${filtro}`)
    .then((result) => {
      callback(result);
    });
  return {
    type: "",
    payload: {},
  };
}

export function postLote(params, callback, errorHandler) {
  axios
    .post(`${ROOT_URL}/Lotes/enviar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: null,
  };
}

export function deleteCobranca(idCobranca, callback, errorHandler) {
  axios
    .delete(`${ROOT_URL}/Cobrancas/excluir/${idCobranca}`)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: null,
  };
}

export function getAllCobrancas(
  actualTablePage,
  idPrestador,
  callback,
  errorHandler
) {
  axios
    .get(`${ROOT_URL}/Cobrancas/listar/${idPrestador}/${actualTablePage}`)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function getAllFilteredCobrancas(params, callback, errorHandler) {
  axios
    .post(`${ROOT_URL}/Cobrancas/filtro/listar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function getAllGuias(
  actualTablePage,
  idPrestador,
  callback,
  errorHandler
) {
  axios
    .get(`${ROOT_URL}/Guia/listar/${idPrestador}/${actualTablePage}`)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function postGuias(params, callback, errorHandler) {
  axios
    .post(`${ROOT_URL}/Guia/filtro/listar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: {},
  };
}

export function getProfissionaisSolicitantes(callback) {
  axios.get(`${ROOT_URL}/Profissional/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getProfissionaisSolicitantesFiltro(filtro, callback) {
  axios
    .get(`${ROOT_URL}/Profissional/filtrar?filtro=${filtro}`)
    .then((result) => {
      callback(result);
    });

  return {
    type: "",
    payload: {},
  };
}

export function postProfissionalSolicitante(params, callback, errorHandler) {
  const request = axios
    .post(`${ROOT_URL}/Profissional/inserir`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: "",
    payload: request,
  };
}

export function getOcupacoes(callback) {
  axios.get(`${ROOT_URL}/Ocupacao/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getEstados(callback) {
  axios.get(`${ROOT_URL}/Estados/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getConselhos(callback) {
  axios.get(`${ROOT_URL}/Conselhos/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getTiposConsulta(callback) {
  axios.get(`${ROOT_URL}/TipoConsulta/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function getIndicacoesAcidente(callback) {
  axios.get(`${ROOT_URL}/IndicacaoAcidente/listar`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function updateBeneficiatioState(params) {
  return {
    type: UPDATE_BENEFICIARIO_STATE,
    payload: params,
  };
}

export function resetBeneficiarioState() {
  return {
    type: RESET_BENEFICIARIO_STATE,
    payload: {},
  };
}

export function postAtendimento(params, callback, errorHandler) {
  const request = axios
    .post(`${ROOT_URL}/Atendimentos/salvar`, params)
    .then((result) => {
      callback(result);
    })
    .catch((error) => {
      errorHandler(error);
    });
  return {
    type: POST_ATENDIMENTO,
    payload: request,
  };
}

export function getPrestador(login, callback) {
  axios.get(`${ROOT_URL}/Prestador/${login}`).then((result) => {
    callback(result);
  });
  return {
    type: "",
    payload: {},
  };
}

export function updatePrestador(params) {
  return {
    type: UPDATE_PRESTADOR,
    payload: params,
  };
}
